import React from 'react'
import { Box, Grid, Typography } from '@mui/material'
import { CharacterGrid } from '../styles/ProfileEditDialog.styles'
import Adam from '../../images/login/Adam_login.png'
import Ash from '../../images/login/Ash_login.png'
import Lucy from '../../images/login/Lucy_login.png'
import Nancy from '../../images/login/Nancy_login.png'

/** The in-game characters a person can pick. `name` is what `Profile.gameCharacter` stores. */
export const GAME_CHARACTERS = [
  { name: 'adam', label: 'Adam', img: Adam },
  { name: 'ash', label: 'Ash', img: Ash },
  { name: 'lucy', label: 'Lucy', img: Lucy },
  { name: 'nancy', label: 'Nancy', img: Nancy },
] as const

interface CharacterPickerProps {
  value: string
  onChange: (character: string) => void
}

/** The character grid, shared by the profile dialog and the onboarding "Your Sevv self" step. */
const CharacterPicker: React.FC<CharacterPickerProps> = ({ value, onChange }) => (
  <CharacterGrid container spacing={3} justifyContent="center" role="radiogroup" aria-label="Character">
    {GAME_CHARACTERS.map((character) => (
      <Grid item key={character.name} xs={6} sm={3}>
        <Box
          role="radio"
          aria-checked={value === character.name}
          aria-label={character.label}
          tabIndex={0}
          className={`character-item ${value === character.name ? 'selected' : ''}`}
          onClick={() => onChange(character.name)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault()
              onChange(character.name)
            }
          }}
        >
          <Box className="character-image-container">
            <img src={character.img} alt={character.label} className="character-image" />
          </Box>
          <Typography className="character-label">{character.label}</Typography>
        </Box>
      </Grid>
    ))}
  </CharacterGrid>
)

export default CharacterPicker
